import { BaseState } from "..";
import { LoadingState } from "types";
import { WalrDatasetDto, WalrProjectsDto } from "app/SharedApiClient";
import { WalrProjectDto } from "app/ApiClient";

export interface WalrProjectState extends BaseState {
    loading: LoadingState;
    createWalrDataProjectState: LoadingState;
    data: WalrProjectsDto[] | null;
    isCreateWalrProjectDialogOpened: boolean;
    processing: boolean;
    finished: boolean;
    failed: boolean;
    succeed: boolean;
    error: string;    
    getListLoading: LoadingState;
    getProjectLoadingState: LoadingState,
    getDatasetsLoadingState: LoadingState,
    projectDatasets: WalrDatasetDto[] | null;
    projectId?: string;
    createWalrProject?: WalrProjectDto;
 }
  
 export const initialWalrProjectState: WalrProjectState = {
    loading: LoadingState.idle,
    createWalrDataProjectState: LoadingState.idle,
    data: null,
    isCreateWalrProjectDialogOpened: false,
    processing: false,
    finished: false,
    failed: false,
    succeed: false,
    error: "",    
    getProjectLoadingState: LoadingState.idle,
    getDatasetsLoadingState: LoadingState.idle,
    getListLoading: LoadingState.idle,
    projectDatasets: null    
  };
  

